import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import LayersIcon from "@mui/icons-material/Layers";
import BookOnlineRoundedIcon from "@mui/icons-material/BookOnlineRounded";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LogoutIcon from "@mui/icons-material/Logout";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import StoreIcon from "@mui/icons-material/Store";
import PaymentIcon from "@mui/icons-material/Payment";
import { handleLogout } from "../Layout/function";
import { NavLink } from "react-router-dom";
import "./Menu.css";

function getNavClass(navLinkProps) {
  let navClass = "menu-item";
  if (navLinkProps.isActive) navClass += " menu-item-active";
  return navClass;
}

export const mainMenuListItems = (
  <React.Fragment>
    {/*<NavLink className={getNavClass} to="/dashboard">
      <ListItemButton className={getNavClass}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
    </NavLink>
  */}
    <NavLink className={getNavClass} to="/cms-catalogs">
      <ListItemButton className={getNavClass}>
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <ListItemText primary="Catalogs" />
      </ListItemButton>
    </NavLink>

    <NavLink className={getNavClass} to="/cms-account">
      <ListItemButton className={getNavClass}>
        <ListItemIcon>
          <SupervisorAccountIcon />
        </ListItemIcon>
        <ListItemText primary="Account" />
      </ListItemButton>
    </NavLink>
  </React.Fragment>
);

export const secondaryMenuListItems = (
  <React.Fragment>
    <ListItemButton onClick={() => this.props.history.push("/cms-profile")}>
      <ListItemIcon>
        <AccountBoxIcon />
      </ListItemIcon>
      <ListItemText primary="Profile" />
    </ListItemButton>
    <ListItemButton onClick={handleLogout}>
      <ListItemIcon>
        <LogoutIcon />
      </ListItemIcon>
      <ListItemText primary="Logout" />
    </ListItemButton>
  </React.Fragment>
);
